import { type BoxStaffInvitationDetailsDto, BoxStaffRole, BoxStaffStatus } from "@modules/boxStaff/gateway/boxStaffDto"
import { UserEntity } from "@modules/profile/userProfile/userEntity"

export class BoxStaffInvitationDetailsEntity {
  boxId: string
  inviter: UserEntity | null
  status: BoxStaffStatus
  role: BoxStaffRole

  constructor(boxStaffInvitation: BoxStaffInvitationDetailsEntity) {
    this.boxId = boxStaffInvitation.boxId
    this.inviter = boxStaffInvitation.inviter
    this.status = boxStaffInvitation.status
    this.role = boxStaffInvitation.role
  }

  static fromDto(dto: BoxStaffInvitationDetailsDto): BoxStaffInvitationDetailsEntity {
    return new BoxStaffInvitationDetailsEntity({
      boxId: dto.boxId,
      inviter: dto.inviter ? UserEntity.fromDto(dto.inviter) : null,
      status: dto.status,
      role: dto.role,
    })
  }
}
